var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00455 1.82364C0.814401 1.64601 0.736131 1.37851 0.800441 1.12606C0.86475 0.873615 1.06138 0.67649 1.3132 0.61202C1.56501 0.547549 1.83185 0.626015 2.00903 0.816636L4.8576 3.67139L7.70521 0.816636C7.88239 0.626015 8.14923 0.547549 8.40105 0.61202C8.65286 0.67649 8.84949 0.873615 8.9138 1.12606C8.97811 1.37851 8.89984 1.64601 8.7097 1.82364L5.34657 5.19614C5.19298 5.35 4.97766 5.42504 4.76199 5.39987C4.54632 5.37469 4.35396 5.25206 4.23974 5.06694L1.00455 1.82364Z",
    fill: "#31393C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default ForwardRef;